<template>
    <div class="cookie_policy__container">
        <vue-cookie-accept-decline
            elementId="cookie-accept"
            type="bar"
            position="bottom"
            :disableDecline="true"
            @clicked-accept="acceptedPolicy"
            ref="policy"
        >
            <template #message>
                <p class="p-0">
                    {{ $t('backend.main.cookie.msg') }}
                    <a :href="$t('backend.main.cookie.more_link')" target="_blank">{{ $t('backend.main.cookie.more') }}</a>
                </p>
            </template>
            <template #acceptContent>{{ $t('backend.main.cookie.btn') }}</template>
        </vue-cookie-accept-decline>
    </div>
</template>
<script>
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';
import Verbox from "../mixins/Verbox";

export default {
    name: "CookiePolicy",
    mixins: [Verbox],
    mounted() {
        if (this.$refs.policy.status !== 'accept') {
            this.onHideVerboxIcon();
        }
    },
    methods: {
        acceptedPolicy() {
            this.onShowVerboxIcon();
        }
    },
    components: {
        VueCookieAcceptDecline,
    },
}
</script>
<style scoped>
.cookie_policy__container {
    z-index: 100000;
}
.cookie_policy__container > div {
    background: #424851;
    color: #fff;
    padding: 1.25em;
    border: 0;
    box-shadow: none;
    font-family: inherit;
}
.cookie_policy__container:deep(p) {
    line-height: 20px;
}
.cookie_policy__container:deep(a) {
    font-size: 14px;
    text-decoration: underline;
    display: inline-block;
    color: #fff;
}
.cookie_policy__container:deep(button) {
    background: var(--primary-color);
    color: var(--primary-color-text);
    border-radius: var(--border-radius);
    border: 1px solid var(--primary-color);
    padding: 0.875rem 1.5rem;
    font-size: 0.875rem;
    line-height: 1rem;
}
@media (max-width: 768px) {
    .cookie_policy__container:deep(p) {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        line-height: 20px;
    }
    .cookie_policy__container:deep(a) {
        margin-top: 12px;
    }
}
</style>
